<template>
  <div class="date-picker-row">
    <template v-for="(year, index) in yearList">
      <div
        :key="`date-picker-year-${index}`"
        class="date-picker-cell"
      >
        <div
          :class="getClass(year)"
          @click="e => handleYearClick(e, { year })"
        >
          {{ year }}
        </div>
      </div>
      <div
        v-if="(index + 1) % 4 === 0"
        :key="`date-picker-year-break-${(index + 1) / 4}`"
        class="date-picker-break"
      />
    </template>
    <div
      class="date-picker-shortcut-button"
      @click="setThisYear"
    >
      {{ getShortcutCopy('year') }}
    </div>
  </div>
</template>

<script>
import DatePickerMixins from '../mixins';

export default {
  name: 'MDatepickerYearPicker',
  mixins: [
    DatePickerMixins,
  ],
  props: {
    pickerYear: {
      type: Number,
      default: 2020,
    },
    selectedYear: {
      type: Number,
      default: 2020,
    },
    yearList: {
      type: Array,
      default: () => [],
    },
    language: {
      type: String,
      default: 'en',
    },
    disabledDates: {
      type: Object,
      default: null,
    },
  },
  methods: {
    setThisYear() {
      const date = new Date();
      const params = {
        year: date.getFullYear(),
        from: 'yearPicker',
      };
      this.$emit('update-selected-date', { ...params });
    },
    handleYearClick(event, { year }) {
      const classes = event.target.className;

      // emit date change event only if it's not disabled
      if (!classes.includes('disabled')) this.$emit('update-selected-date', { year, from: 'yearPicker' });
    },
    getClass(year) {
      const today = new Date();
      return {
        'date-picker-year-cell': true,
        'current-year': year === today.getFullYear(),
        'selected-year': year === this.selectedYear,
        'disabled-year': this.isDisabledYear(year),
      };
    },
    isDisabledYear(currentYear) {
      let disabledYear = false;
      if (!this.disabledDates) return false;

      if (this.disabledDates.to) {
        const toDate = new Date(this.disabledDates.to);
        
        if (currentYear < toDate.getFullYear()) disabledYear = true;
      }

      if (this.disabledDates.from) {
        const fromDate = new Date(this.disabledDates.from);
        
        if (currentYear > fromDate.getFullYear()) disabledYear = true;
      }

      return disabledYear;
    },
  },
};
</script>
